<script>
  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'

  export default {
    name: 'imprimir-boleto',
    props: ['titulo', 'descricaoLink'],
    data () {
      return {
        pdfBase64: '',
        mostrarModalPdf: false
      }
    },
    computed: {
      habilitarImpressaoBoleto () {
        return this.titulo.mostrar_boleto &&
          this.titulo.saldo &&
          Math.sign(this.titulo.saldo) > 0 &&
          this.titulo.cod_boleto !== null
      }
    },
    methods: {
      imprimirPdf () {
        bus.$emit('show-loader')
        restfulService.get('boleto', 'pdf', this.titulo.id)
          .then((response) => {
            this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
            this.mostrarModalPdf = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <v-btn color="info"
               fab small
               :depressed="true"
               v-if="habilitarImpressaoBoleto && !descricaoLink"
               title="Imprimir Boleto"
               @click="imprimirPdf">
            <i class="fas fa-print"></i>
        </v-btn>
        <a href="#" v-if="habilitarImpressaoBoleto && descricaoLink"
               title="Imprimir Boleto"
               @click.prevent="imprimirPdf">{{ descricaoLink }}</a>
        <span v-if="titulo.cod_boleto === null && !descricaoLink">
            Boleto não disponível<br>
            Entre em contato com o setor financeiro
        </span>
        <v-dialog v-model="mostrarModalPdf" width="80%">
            <v-card class="modal-pdf">
                <v-card-text>
                    <iframe :src="pdfBase64"></iframe>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalPdf = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// ImprimirBoleto.vue?0ee03b92